import { Button, cx } from '@otter-ai/den-components';
import { FILE_STATES, useAbortItem } from '@rpldy/uploady';
import { useRouter } from 'next/navigation';
import { useModalController } from '@/shared/modals';
import type { UploadItem } from '../types/types';

export function UploadStatus({
  item,
  isMobile,
}: {
  item: UploadItem;
  isMobile: boolean;
}) {
  const abort = useAbortItem();
  const router = useRouter();
  const { hideModal } = useModalController();

  function navigateToTranscript() {
    if (!item?.otid) {
      return;
    }
    // close the import modal
    hideModal();
    router.push(`/u/${item.otid}?view=transcript`);
  }

  switch (item.state) {
    case FILE_STATES.ADDED:
    case FILE_STATES.PENDING:
      return <span>Waiting</span>;

    case FILE_STATES.UPLOADING:
      return (
        <Button
          className={cx(
            'p-0',
            isMobile &&
              'text-[12px] m-0 h-auto min-h-0 bg-transparent border-0 shadow-none',
          )}
          size="md"
          variant="ghost"
          onClick={() => abort(item.id)}
        >
          <span className="text-primary">Cancel</span>
        </Button>
      );

    case FILE_STATES.FINISHED:
      return isMobile ? (
        <span className="flex flex-col items-end">Transcribing...</span>
      ) : (
        <Button
          className="p-0"
          size="md"
          variant="ghost"
          onClick={navigateToTranscript}
        >
          <span className="text-primary flex flex-col items-start">
            <span>Go to</span>
            <span>transcript</span>
          </span>
        </Button>
      );
    case FILE_STATES.CANCELLED:
    case FILE_STATES.ABORTED:
      return <span>Cancelled</span>;

    case FILE_STATES.ERROR:
      return <span>Error</span>;
  }
}
